export const captionHeight = 30;
export const imageWidth = 320;
export const imageHeight = 223;
export const imageAspectRatio = imageHeight / imageWidth;
